export const unitsTranslations = {
    MINUTES: "Min.",
    FEE: "pauschal",
    EMPTY: "-",
};
export const learningTaskAnswerVersionStatusTranslations = {
    draft: "In Bearbeitung",
    submitted: "Eingereicht",
    accepted: "Akzeptiert",
    improvement_requested: "Soll verbessert werden",
};
export const learningTaskAnswerVersionStatusPhrases = Object.fromEntries(Object.entries(learningTaskAnswerVersionStatusTranslations).map(([k, v]) => [
    k,
    `Antwort ${v
        .split(" ")
        .map((w, i) => (i === 0 ? w.toLowerCase() : w))
        .join(" ")}`,
]));
